import React from 'react';
import './TopBar.scss';
import { Icon } from '../../atoms/Icon/Icon';

interface ProcessingTopBarProps {
  [key: string]: any;
}

const ProcessingTopBar = (props: ProcessingTopBarProps) => {
  // use your props here

  const onCreateNewBorrowerLoan = () => {
    window.open(window.location.origin, '_blank');
  }

  return (
    <div className="top-bar">
      <div className='logo' onClick={() => { window.location.href = "https://www.constlending.com"; }}>
        <Icon svgFilePath={"./assets/icons/constlending-logo.svg"} />
      </div>
      <div className="internal">
        INTERNAL
      </div>
      <div className='button-blue-outlined' onClick={onCreateNewBorrowerLoan}>
        Create New Borrower Loan
      </div>
    </div>
  );
};

export default ProcessingTopBar;